import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const SpotprisIdag = lazy(() => import("@/pages/spotpris/SpotprisIdag"));

export const Route = createFileRoute("/spotpris/idag")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => seoHead("/spotpris/idag", { description: "Se dagens spotpris timme för timme i SE1, SE2, SE3 och SE4. Priserna kommer från Nord Pool och uppdateras automatiskt." }),
  component: () => <SpotprisIdag />,
});
